/**
 * Identifier Validation Types
 *
 * Shared types for parametric serial/lot validation rules.
 * Used by backend-wms (entities, services) and frontend (real-time validation).
 *
 * DRY Compliance: Single source of truth for validation enums and interfaces.
 */

/** Rule applies to serial numbers or lot numbers */
export enum IdentifierRuleType {
  SERIAL = 'SERIAL',
  LOT = 'LOT',
}

/** Allowed character set for identifier values */
export enum CharacterSet {
  NUMERIC = 'NUMERIC',
  ALPHANUMERIC = 'ALPHANUMERIC',
  FULL_ASCII = 'FULL_ASCII',
}

/** Checksum algorithm for identifier validation */
export enum ChecksumAlgorithm {
  NONE = 'NONE',
  LUHN = 'LUHN',
  MOD10 = 'MOD10',
  MOD43 = 'MOD43',
}

/** Configuration for a single validation rule */
export interface IdentifierValidationConfig {
  min_length?: number;
  max_length?: number;
  prefix?: string;
  suffix?: string;
  /** Regex pattern string (without delimiters) */
  pattern?: string;
  character_set?: CharacterSet;
  checksum_algorithm?: ChecksumAlgorithm;
  /** Example value for UI hint */
  example?: string;
  /** Custom error message override */
  error_message?: string;
}

/** Result of validating an identifier value */
export interface IdentifierValidationResult {
  valid: boolean;
  error?: string;
  /** Name of the rule that matched/failed */
  matched_rule?: string;
}
